;(function() {
  'use strict'

  angular.module('app.core').factory('quotaCellsService', Factory)

  /* @ngInject */
  function Factory() {
    return {
      getCells: getCells,
      isBroken: isBroken,
      getAxes: getAxes,
      hasEmptyAxis: hasEmptyAxis,
    }

    function getCells(quota, questions) {
      if (!quota) return []

      var axes = getAxes(quota, questions)
      if (!axes.length) return []
      // a variable whose question has lost its choices yields no cells at all, which isBroken reports separately
      if (hasEmptyAxis(axes)) return []

      var cells = quota.isIndependent()
        ? getIndependentCells(quota, axes, questions)
        : getInterlockedCells(quota, axes)

      reportDuplicateKeys(quota, cells)

      return cells
    }

    // a duplicate key double counts every summary built from these cells, and nothing else reports it - see toToken in QuotaDefinition
    function reportDuplicateKeys(quota, cells) {
      var byKey = _.groupBy(cells, 'cellKey')

      _.each(byKey, function(group, cellKey) {
        if (group.length < 2) return

        console.error(
          'quotaCellsService: ' +
            group.length +
            ' cells share key ' +
            cellKey +
            ' in quota ' +
            quota.id +
            ' - ' +
            _.map(group, 'label').join(', ')
        )
      })
    }

    function isBroken(quota, questions) {
      if (!quota) return false

      var axes = getAxes(quota, questions)
      if (!axes.length) return false

      return hasEmptyAxis(axes)
    }

    function hasEmptyAxis(axes) {
      return _.some(axes, function(axis) {
        return !axis.options.length
      })
    }

    function getAxes(quota, questions) {
      return quota
        .getVariablesInDisplayOrder(questions)
        .map(function(variable) {
          var question = _.find(questions, { id: variable.questionId })

          return {
            variable: variable,
            label: variable.getShortLabel(questions),
            options: variable.getOptions(question),
          }
        })
    }

    function getIndependentCells(quota, axes, questions) {
      var cells = []

      axes.forEach(function(axis) {
        var variableLabel = axis.variable.getShortLabel(questions)
        axis.options.forEach(function(option) {
          var optionIdByVariableId = {}
          optionIdByVariableId[axis.variable.id] = option.id

          cells.push(
            makeCell(
              quota,
              optionIdByVariableId,
              variableLabel + ' · ' + option.label
            )
          )
        })
      })

      return cells
    }

    function getInterlockedCells(quota, axes) {
      var cells = []

      walk(0, [])

      return cells

      function walk(depth, combination) {
        if (depth === axes.length) {
          var optionIdByVariableId = {}

          axes.forEach(function(axis, index) {
            optionIdByVariableId[axis.variable.id] = combination[index].id
          })

          var label = combination
            .map(function(option) {
              return option.label
            })
            .join(' × ')

          cells.push(makeCell(quota, optionIdByVariableId, label))
          return
        }

        axes[depth].options.forEach(function(option) {
          walk(depth + 1, combination.concat([option]))
        })
      }
    }

    // the key comes from a map, so it is built in variable id order whatever display order these axes arrived in
    function makeCell(quota, optionIdByVariableId, label) {
      return {
        label: label,
        cellKey: quota.getCellKey(optionIdByVariableId),
        counterName: quota.getCounterName(optionIdByVariableId),
      }
    }
  }
})()
